import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * MissionChecker — Polls for newly auto-completed missions and shows toast notifications.
 * Runs once on mount and then every 60 seconds when user is authenticated.
 */
export default function MissionChecker() {
  const { isAuthenticated } = useAuth();
  const checkedRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated) return;

    const check = async () => {
      try {
        const res = await axios.get(`${API}/api/missions/check-new`, { withCredentials: true });
        const { newly_completed } = res.data;
        if (newly_completed && newly_completed.length > 0) {
          newly_completed.forEach(m => {
            toast.success(`Mission Complete: ${m.title}! +${m.xp} XP`, {
              duration: 5000,
              description: m.badge ? `Badge unlocked: ${m.badge.name}` : undefined,
            });
          });
        }
      } catch {
        // Silent fail — not critical
      }
    };

    // Check after a short delay on first mount (avoid spamming on page load)
    const initial = setTimeout(() => {
      if (!checkedRef.current) {
        checkedRef.current = true;
        check();
      }
    }, 3000);

    // Periodic check every 60s
    const interval = setInterval(check, 60000);

    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, [isAuthenticated]);

  return null; // Render nothing — this is a behavior-only component
}
